"use strict";
exports.__esModule = true;
exports.InviteUserUpdate = exports.InviteMemberDocument = void 0;
var InviteMemberDocument = /** @class */ (function () {
    function InviteMemberDocument(org_id, organisation_name, app_domain, uid, email, created_at, first_name, last_name, invite_token) {
        if (first_name === void 0) { first_name = ''; }
        if (last_name === void 0) { last_name = ''; }
        if (invite_token === void 0) { invite_token = ''; }
        this.org_id = org_id;
        this.organisation_name = organisation_name;
        this.app_domain = app_domain;
        this.uid = uid;
        this.email = email;
        this.created_at = created_at;
        this.first_name = first_name;
        this.last_name = last_name;
        this.invite_token = invite_token;
    }
    InviteMemberDocument.fromJSON = function (json) {
        var organisationMember = new InviteMemberDocument('', '', '', '', '', 0, '', '', '');
        if (json) {
            organisationMember.org_id = json.org_id ? json.org_id : '';
            organisationMember.organisation_name = json.organisation_name ? json.organisation_name : '';
            organisationMember.app_domain = json.app_domain ? json.app_domain : '';
            organisationMember.uid = json.uid ? json.uid : '';
            organisationMember.email = json.email ? json.email : '';
            organisationMember.created_at = json.created_at ? json.created_at : 0;
            organisationMember.first_name = json.first_name ? json.first_name : '';
            organisationMember.last_name = json.last_name ? json.last_name : '';
            organisationMember.invite_token = json.invite_token ? json.invite_token : '';
        }
        return organisationMember;
    };
    return InviteMemberDocument;
}());
exports.InviteMemberDocument = InviteMemberDocument;
var InviteUserUpdate = /** @class */ (function () {
    function InviteUserUpdate(uid, first_name, last_name, password) {
        this.uid = uid;
        this.first_name = first_name;
        this.last_name = last_name;
        this.password = password;
    }
    InviteUserUpdate.fromJSON = function (json) {
        var inviteUserUpdate = new InviteUserUpdate('', '', '', '');
        if (json) {
            inviteUserUpdate.uid = json.uid ? json.uid : '';
            inviteUserUpdate.first_name = json.first_name ? json.first_name : '';
            inviteUserUpdate.last_name = json.last_name ? json.last_name : '';
            inviteUserUpdate.password = json.password ? json.password : '';
        }
        return inviteUserUpdate;
    };
    return InviteUserUpdate;
}());
exports.InviteUserUpdate = InviteUserUpdate;
